import { Suspense } from 'react';
import { trackEvent } from '@kcd/event-tracker';

import { Chip } from '~/components/Chip';
import { SEARCH_ROUTER, TAX_EASE_ROUTER } from '~/constants/router';
import { useRecommendSearchKeywords } from '~/domains/keyword/queries';
import { openPageModal } from '~/utils/mobileApp';

const RecommendKeywordList = () => {
  const [value] = useRecommendSearchKeywords();

  const onClickRecommendkeyword = (keyword: string) => {
    trackEvent('clicked tab in 마켓/검색', {
      keyword,
      clicked_area: '추천 검색어',
    });

    openPageModal(SEARCH_ROUTER.searchText(keyword));
  };

  return (
    <div className="overflow-x-auto whitespace-nowrap px-20 py-8 [&::-webkit-scrollbar]:hidden">
      <Chip
        className="!mr-8 !inline-block"
        onClick={() => {
          openPageModal(TAX_EASE_ROUTER.root);
        }}
      >
        세무이지
      </Chip>
      {value?.recommendKeywords.map((keyword) => (
        <Chip
          className="!mr-8 !inline-block"
          key={keyword}
          onClick={() => {
            onClickRecommendkeyword(keyword);
          }}
        >
          {keyword}
        </Chip>
      ))}
    </div>
  );
};

export default function RecommendKeywords() {
  return (
    <Suspense fallback={<div className="h-[44px] w-full" />}>
      <RecommendKeywordList />
    </Suspense>
  );
}
